// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZkWI","fullView":"styles_fullView__3orR7"};